import src from "IMAGE";
export default { src, width: 1096, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAYdM/8GHTP/CSI6/wslP/8OK0f/DChC/wokPf8JIzz/q5gLQuXPlcsAAAAASUVORK5CYII="};
